import { useEffect, useMemo } from 'react';

import {
  fetchServerTime,
  getCurrentServerTime,
  serverTimeState,
} from '../../helpers/serverTime';
import { selectServerTime } from '../../modules/ui';
import { setServerTime } from '../../modules/ui/actions';
import { useAppDispatch, useAppSelector } from '../../modules/hooks';

function useServerTime() {
  const dispatch = useAppDispatch();

  const serverTime = useAppSelector(selectServerTime);

  const currentServerTime = useMemo(
    () => getCurrentServerTime(serverTime),
    [serverTime]
  );

  // this hook will trigger a single server time fetch throughout the entire lifespan of the app
  useEffect(() => {
    (async () => {
      if (serverTimeState.isFetched || serverTimeState.isFetching) {
        return;
      }

      const serverTime = await fetchServerTime();

      dispatch(setServerTime(serverTime));
    })();
  }, [dispatch]);

  return { serverTime: currentServerTime };
}

export { useServerTime };
